import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { CheckCircle2, Circle, GraduationCap } from "lucide-react";
import { toast } from "sonner";

export default function Training() {
  const [mods, setMods] = useState([]);
  const load = () => api.get("/agent/training").then((r) => setMods(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const done = mods.filter((m) => m.completed).length;
  const pct = mods.length ? Math.round((done / mods.length) * 100) : 0;

  const complete = async (id) => { await api.post(`/agent/training/${id}/complete`); toast.success("Module completed"); load(); };

  return (
    <div>
      <PageTitle title="Training" subtitle="Recommended curriculum for the private-pay placement business" />
      <Card className="mb-6 p-6">
        <div className="flex items-center gap-3"><GraduationCap className="h-5 w-5 text-clinical" /><h3 className="font-heading font-semibold text-navy">Your progress</h3></div>
        <Progress value={pct} className="mt-4" />
        <p className="mt-2 text-sm text-slate-500">{done} of {mods.length} modules complete ({pct}%)</p>
      </Card>
      <div className="space-y-3">
        {mods.map((m) => (
          <Card key={m.id} className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid={`module-${m.order}`}>
            <div className="flex items-start gap-4">
              <span className="mt-0.5 font-heading text-lg font-bold text-slate-300">{m.order}</span>
              <div>
                <p className="font-heading font-semibold text-navy">{m.title}</p>
                <p className="mt-0.5 text-sm text-slate-500">{m.description}</p>
              </div>
            </div>
            <Button variant={m.completed ? "secondary" : "default"} onClick={() => complete(m.id)} disabled={m.completed}
              data-testid={`module-complete-${m.order}`} className={m.completed ? "" : "bg-navy hover:bg-navy/90"}>
              {m.completed ? <><CheckCircle2 className="mr-2 h-4 w-4 text-emeraldbrand" /> Completed</> : <><Circle className="mr-2 h-4 w-4" /> Mark complete</>}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
